import { render, staticRenderFns } from "./MailAppPasswordPage.vue?vue&type=template&id=66fc8bc0&scoped=true&"
import script from "./MailAppPasswordPage.vue?vue&type=script&lang=ts&"
export * from "./MailAppPasswordPage.vue?vue&type=script&lang=ts&"
import style0 from "./MailAppPasswordPage.vue?vue&type=style&index=0&id=66fc8bc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fc8bc0",
  null
  
)

export default component.exports